import React from 'react';
import { Avatar, Box, IconButton } from '@mui/material';
import { getStaticFileUrl } from '../../../utils/staticUtils';
import { MOBILE_APP_HEADER_HEIGHT, mobileShellHeaderSx } from './mobileAppTheme';

export default function LandingMobileHeader({ user, onProfileClick, onLogoClick }) {
  const initial = user?.username?.[0]?.toUpperCase() || 'U';

  return (
    <Box
      component="header"
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
        pt: 'env(safe-area-inset-top)',
        px: 2,
        pb: 1.25,
        minHeight: `calc(${MOBILE_APP_HEADER_HEIGHT}px + env(safe-area-inset-top))`,
        ...mobileShellHeaderSx,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
        <Box
          component="img"
          src={getStaticFileUrl('topbar/logo_ed_dark.png')}
          alt="RoomNexa"
          onClick={onLogoClick}
          sx={{
            height: 40,
            width: 'auto',
            objectFit: 'contain',
            cursor: onLogoClick ? 'pointer' : 'default',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            right: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            display: 'flex',
            alignItems: 'center',
            gap: 0.75,
          }}
        >
          <IconButton
            onClick={onProfileClick}
            aria-label="Account menu"
            sx={{
              color: '#e2e8f0',
              border: '1px solid rgba(255,255,255,0.08)',
              backgroundColor: 'rgba(0,0,0,0.45)',
              width: 40,
              height: 40,
              p: 0,
            }}
          >
          <Avatar
            sx={{
              width: 32,
              height: 32,
              bgcolor: '#4ce1b6',
              color: '#04120e',
              fontSize: '14px',
              fontWeight: 600,
            }}
          >
            {initial}
          </Avatar>
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
}
